module.exports = __webpack_public_path__ + "static/media/colossal-closer.8af358ec.jpg";